<template>
  <div>
    <el-dialog :title="form.id?'编辑课件':'新增课件'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="课件：" prop="wareUrlArr" class="width100">
          <fileUpload v-model="form.wareUrlArr" hintText="支持上传格式PPT，PPTX，PDF" isWatermark="1" limitType=".ppt,.pptx,.pdf" />
        </el-form-item>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import courseSubjectWaresApi from '@/api/course/courseSubjectWares'
import FileUpload from "@/components/FileUpload"
function initFormBean() {
  const formBean = {
    wareUrlArr: [],
    state: 1,
  }
  return formBean
}

export default {
  props: ['rowItem'],
  components: { FileUpload },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        wareUrlArr: [{ required: true, message: '请上传课件', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.$set(this.form, 'wareUrlArr', [{ url: row.wareUrl, name: row.wareUrl }])
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcEditData() {


    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      if (params.wareUrlArr.length > 0) {
        params.wareUrl = params.wareUrlArr[0].url
      }
      delete params.wareUrlArr
      params.subjectId = this.rowItem.id
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          if (this.isRepSub) return
          this.isRepSub = true
          if (params.id > 0) {
            courseSubjectWaresApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseSubjectWaresApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
